import { useState, useEffect } from "react";

// Zippopotam.us country code map
const ZIPPO_COUNTRY = {
  US: "us", CA: "ca", AU: "au", GB: "gb", IE: "ie", FR: "fr", ES: "es",
};

const usePostalLookup = ({ zipcode, country, onResult }) => {
  const [zipStatus, setZipStatus] = useState("idle");

  useEffect(() => {
    if (!zipcode || zipcode.length < 3) { setZipStatus("idle"); return; }
    const zippoCode = ZIPPO_COUNTRY[country];
    if (!zippoCode) { setZipStatus("idle"); return; }

    const timer = setTimeout(async () => {
      setZipStatus("loading");
      try {
        const res = await fetch(`https://api.zippopotam.us/${zippoCode}/${zipcode.replace(/\s/g, "")}`);
        if (!res.ok) { setZipStatus("notfound"); return; }
        const data = await res.json();
        if (data.places && data.places.length > 0) {
          const place = data.places[0];
          onResult({ city: place["place name"], state: place["state abbreviation"] || place["state"] });
          setZipStatus("found");
        } else {
          setZipStatus("notfound");
        }
      } catch {
        setZipStatus("error");
      }
    }, 600);

    return () => clearTimeout(timer);
  }, [zipcode, country]); // eslint-disable-line react-hooks/exhaustive-deps

  return zipStatus;
};

export { usePostalLookup };
export default usePostalLookup;